import { TurretMenu } from "./TurretMenu";
import { GameVars } from "../../../GameVars";
import * as Creepts from "endless-siege-engine";

export class InfoLayer extends Phaser.GameObjects.Container {
    
    private turretMenu: TurretMenu;

    private damageText: Phaser.GameObjects.Text;
    private damageIncText: Phaser.GameObjects.Text;
    private intensityText: Phaser.GameObjects.Text;
    private intensityIncText: Phaser.GameObjects.Text;
    private distanceText: Phaser.GameObjects.Text;
    private distanceIncText: Phaser.GameObjects.Text;
    private durationText: Phaser.GameObjects.Text;
    private durationIncText: Phaser.GameObjects.Text;
    private reloadText: Phaser.GameObjects.Text;
    private reloadIncText: Phaser.GameObjects.Text;
    private rangeText: Phaser.GameObjects.Text;
    private rangeIncText: Phaser.GameObjects.Text;
    private explosionRangeText: Phaser.GameObjects.Text;
    private explosionRangeIncText: Phaser.GameObjects.Text;
    private inflictedText: Phaser.GameObjects.Text;
    private incContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, turretMenu: TurretMenu) {

        super(scene);

        this.y = -190;

        this.turretMenu = turretMenu;

        this.incContainer = new Phaser.GameObjects.Container(this.scene);

        let offY = 0;
        let bck, img, text, offInc;

        if (this.turretMenu.turret.type === Creepts.GameConstants.TURRET_GLUE) {
            if (this.turretMenu.turret.grade === 3) {
                offInc = 90; 
            } else {
                offInc = 60; 
            }
        } else if (this.turretMenu.turret.type === Creepts.GameConstants.TURRET_LAUNCH) {
            offInc = 45; 
        } else {
            offInc = 60;
        }

        if (this.turretMenu.turret.type !== Creepts.GameConstants.TURRET_GLUE) {

            // DAMAGE

            bck = new Phaser.GameObjects.Graphics(this.scene);
            bck.fillStyle(0xAAAAAA, .35);
            bck.fillRoundedRect(-160, offY, 320, 40, 5);
            this.add(bck);

            img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_damage");
            this.add(img);

            text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Damage:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            text.setOrigin(0, .5);
            text.setStroke("#000000", 4);
            text.setShadow(1, 2, "#000000", 0, true, false);
            this.add(text);

            this.damageText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber(this.turretMenu.turret.damage), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            this.damageText.setOrigin(1, .5);
            this.damageText.setStroke("#000000", 4);
            this.damageText.setShadow(1, 2, "#000000", 0, true, false);
            this.add(this.damageText);

            this.damageIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(this.turretMenu.turret.nextDamage - this.turretMenu.turret.damage), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
            this.damageIncText.setOrigin(1, .5);
            this.damageIncText.setStroke("#000000", 4);
            this.damageIncText.setShadow(1, 2, "#000000", 0, true, false);
            this.incContainer.add(this.damageIncText);

            if (this.turretMenu.turret.nextDamage === 0) {
                this.damageIncText.visible = false;
            }

            offY += offInc;
        } else {

            if (this.turretMenu.turret.grade === 3) {

                // DISTANCE

                bck = new Phaser.GameObjects.Graphics(this.scene);
                bck.fillStyle(0xAAAAAA, .35);
                bck.fillRoundedRect(-160, offY, 320, 40, 5);
                this.add(bck);

                img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_distance_teleport");
                this.add(img);

                text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Distance:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                text.setOrigin(0, .5);
                text.setStroke("#000000", 4);
                text.setShadow(1, 2, "#000000", 0, true, false);
                this.add(text);

                this.distanceText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).teleportDistance), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                this.distanceText.setOrigin(1, .5);
                this.distanceText.setStroke("#000000", 4);
                this.distanceText.setShadow(1, 2, "#000000", 0, true, false);
                this.add(this.distanceText);

                this.distanceIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextTeleportDistance - (this.turretMenu.turret as Creepts.GlueTurret).teleportDistance)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
                this.distanceIncText.setOrigin(1, .5);
                this.distanceIncText.setStroke("#000000", 4);
                this.distanceIncText.setShadow(1, 2, "#000000", 0, true, false);
                this.incContainer.add(this.distanceIncText);

                offY += offInc;
            } else {

                // INTENSITY

                bck = new Phaser.GameObjects.Graphics(this.scene);
                bck.fillStyle(0xAAAAAA, .35);
                bck.fillRoundedRect(-160, offY, 320, 40, 5);
                this.add(bck);

                img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_intensity");
                this.add(img);

                text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Intensity:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                text.setOrigin(0, .5);
                text.setStroke("#000000", 4);
                text.setShadow(1, 2, "#000000", 0, true, false);
                this.add(text);

                this.intensityText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).intensity), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                this.intensityText.setOrigin(1, .5);
                this.intensityText.setStroke("#000000", 4);
                this.intensityText.setShadow(1, 2, "#000000", 0, true, false);
                this.add(this.intensityText);

                this.intensityIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextIntensity - (this.turretMenu.turret as Creepts.GlueTurret).intensity)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
                this.intensityIncText.setOrigin(1, .5);
                this.intensityIncText.setStroke("#000000", 4);
                this.intensityIncText.setShadow(1, 2, "#000000", 0, true, false);
                this.incContainer.add(this.intensityIncText);

                offY += offInc;

                // DURATION

                bck = new Phaser.GameObjects.Graphics(this.scene);
                bck.fillStyle(0xAAAAAA, .35);
                bck.fillRoundedRect(-160, offY, 320, 40, 5);
                this.add(bck);

                img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_duration");
                this.add(img);

                text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Duration:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                text.setOrigin(0, .5);
                text.setStroke("#000000", 4);
                text.setShadow(1, 2, "#000000", 0, true, false);
                this.add(text);

                this.durationText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).duration), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
                this.durationText.setOrigin(1, .5);
                this.durationText.setStroke("#000000", 4);
                this.durationText.setShadow(1, 2, "#000000", 0, true, false);
                this.add(this.durationText);

                this.durationIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextDuration - (this.turretMenu.turret as Creepts.GlueTurret).duration)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
                this.durationIncText.setOrigin(1, .5);
                this.durationIncText.setStroke("#000000", 4);
                this.durationIncText.setShadow(1, 2, "#000000", 0, true, false);
                this.incContainer.add(this.durationIncText);

                offY += offInc;
            }
        }

        // RELOAD

        bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0xAAAAAA, .35);
        bck.fillRoundedRect(-160, offY, 320, 40, 5);
        this.add(bck);

        img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_reload");
        this.add(img);

        text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Reload:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
        text.setOrigin(0, .5);
        text.setStroke("#000000", 4);
        text.setShadow(1, 2, "#000000", 0, true, false);
        this.add(text);

        this.reloadText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber(this.turretMenu.turret.reload), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
        this.reloadText.setOrigin(1, .5);
        this.reloadText.setStroke("#000000", 4);
        this.reloadText.setShadow(1, 2, "#000000", 0, true, false);
        this.add(this.reloadText);

        this.reloadIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, GameVars.formatNumber(GameVars.fixNumber(this.turretMenu.turret.nextReload - this.turretMenu.turret.reload)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
        this.reloadIncText.setOrigin(1, .5);
        this.reloadIncText.setStroke("#000000", 4);
        this.reloadIncText.setShadow(1, 2, "#000000", 0, true, false);
        this.incContainer.add(this.reloadIncText);

        if (this.turretMenu.turret.nextReload === 0) {
            this.reloadIncText.visible = false;
        }

        // RANGE

        offY += offInc;

        bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0xAAAAAA, .35);
        bck.fillRoundedRect(-160, offY, 320, 40, 5);
        this.add(bck);

        img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_range");
        this.add(img);

        text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Range:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
        text.setOrigin(0, .5);
        text.setStroke("#000000", 4);
        text.setShadow(1, 2, "#000000", 0, true, false);
        this.add(text);

        this.rangeText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber(this.turretMenu.turret.range), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
        this.rangeText.setOrigin(1, .5);
        this.rangeText.setStroke("#000000", 4);
        this.rangeText.setShadow(1, 2, "#000000", 0, true, false);
        this.add(this.rangeText);

        this.rangeIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(GameVars.fixNumber(this.turretMenu.turret.nextRange - this.turretMenu.turret.range)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
        this.rangeIncText.setOrigin(1, .5);
        this.rangeIncText.setStroke("#000000", 4);
        this.rangeIncText.setShadow(1, 2, "#000000", 0, true, false);
        this.incContainer.add(this.rangeIncText);

        if (this.turretMenu.turret.nextRange === 0) {
            this.rangeIncText.visible = false;
        }

        if (this.turretMenu.turret.type === Creepts.GameConstants.TURRET_LAUNCH) {

            // EXPLOSION RANGE

            offY += offInc;

            bck = new Phaser.GameObjects.Graphics(this.scene);
            bck.fillStyle(0xAAAAAA, .35);
            bck.fillRoundedRect(-160, offY, 320, 40, 5);
            this.add(bck);

            img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_explossion_range");
            this.add(img);

            text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "E. Range:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            text.setOrigin(0, .5);
            text.setStroke("#000000", 4);
            text.setShadow(1, 2, "#000000", 0, true, false);
            this.add(text);

            this.explosionRangeText = new Phaser.GameObjects.Text(this.scene, 75, offY + 20, GameVars.formatNumber((this.turretMenu.turret as Creepts.LaunchTurret).explosionRange), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            this.explosionRangeText.setOrigin(1, .5);
            this.explosionRangeText.setStroke("#000000", 4);
            this.explosionRangeText.setShadow(1, 2, "#000000", 0, true, false);
            this.add(this.explosionRangeText);

            this.explosionRangeIncText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, "+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.LaunchTurret).nextExplosionRange - (this.turretMenu.turret as Creepts.LaunchTurret).explosionRange)), {fontFamily: "Supercell", fontSize: "16px", color: "#00FF00"});
            this.explosionRangeIncText.setOrigin(1, .5);
            this.explosionRangeIncText.setStroke("#000000", 4);
            this.explosionRangeIncText.setShadow(1, 2, "#000000", 0, true, false);
            this.incContainer.add(this.explosionRangeIncText);

            if ((this.turretMenu.turret as Creepts.LaunchTurret).nextExplosionRange === 0) {
                this.explosionRangeIncText.visible = false;
            }
        }

        if (this.turretMenu.turret.type !== Creepts.GameConstants.TURRET_GLUE) {

            // INFLICTED

            offY += offInc;

            bck = new Phaser.GameObjects.Graphics(this.scene);
            bck.fillStyle(0xAAAAAA, .35);
            bck.fillRoundedRect(-160, offY, 320, 40, 5);
            this.add(bck);

            img = new Phaser.GameObjects.Image(this.scene, -140, offY + 20, "texture_atlas_1", "icon_inflicted");
            this.add(img);

            text = new Phaser.GameObjects.Text(this.scene,  -120, offY + 20, "Inflicted:", {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            text.setOrigin(0, .5);
            text.setStroke("#000000", 4);
            text.setShadow(1, 2, "#000000", 0, true, false);
            this.add(text);

            this.inflictedText = new Phaser.GameObjects.Text(this.scene, 155, offY + 20, GameVars.formatNumber(this.turretMenu.turret.inflicted), {fontFamily: "Supercell", fontSize: "16px", color: "#FFFFFF"});
            this.inflictedText.setOrigin(1, .5);
            this.inflictedText.setStroke("#000000", 4);
            this.inflictedText.setShadow(1, 2, "#000000", 0, true, false);
            this.add(this.inflictedText);
        }

        this.add(this.incContainer);

        this.scaleY = .9;

        this.scene.tweens.add({
            targets: this,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (this.turretMenu.turret.type !== Creepts.GameConstants.TURRET_GLUE) {
            // DAMAGE

            this.damageText.setText(GameVars.formatNumber(this.turretMenu.turret.damage)); 
            this.damageIncText.setText("+" + GameVars.formatNumber(this.turretMenu.turret.nextDamage - this.turretMenu.turret.damage)); 

            this.inflictedText.setText(GameVars.formatNumber(this.turretMenu.turret.inflicted)); 


        } else {

            if (this.turretMenu.turret.grade === 3) {
                this.distanceText.setText(GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).teleportDistance)); 
                this.distanceIncText.setText("+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextTeleportDistance - (this.turretMenu.turret as Creepts.GlueTurret).teleportDistance))); 
            } else {
                
                this.intensityText.setText(GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).intensity)); 
                this.intensityIncText.setText("+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextIntensity - (this.turretMenu.turret as Creepts.GlueTurret).intensity))); 

                this.durationText.setText(GameVars.formatNumber((this.turretMenu.turret as Creepts.GlueTurret).duration)); 
                this.durationIncText.setText("+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.GlueTurret).nextDuration - (this.turretMenu.turret as Creepts.GlueTurret).duration))); 
            }
        }

        // RELOAD

        this.reloadText.setText(GameVars.formatNumber(this.turretMenu.turret.reload)); 
        this.reloadIncText.setText(GameVars.formatNumber(GameVars.fixNumber(this.turretMenu.turret.nextReload - this.turretMenu.turret.reload))); 

        // RANGE

        this.rangeText.setText(GameVars.formatNumber(this.turretMenu.turret.range)); 
        this.rangeIncText.setText("+" + GameVars.formatNumber(GameVars.fixNumber(this.turretMenu.turret.nextRange - this.turretMenu.turret.range))); 

        if (this.turretMenu.turret.type === Creepts.GameConstants.TURRET_LAUNCH) {

            // EXPLOSION RANGE

            this.explosionRangeText.setText(GameVars.formatNumber((this.turretMenu.turret as Creepts.LaunchTurret).explosionRange)); 
            this.explosionRangeIncText.setText("+" + GameVars.formatNumber(GameVars.fixNumber((this.turretMenu.turret as Creepts.LaunchTurret).nextExplosionRange - (this.turretMenu.turret as Creepts.LaunchTurret).explosionRange))); 

        }

        if (this.turretMenu.turret.level === this.turretMenu.turret.maxLevel) {
            this.incContainer.visible = false;
        } else {
            this.incContainer.visible = true;
        }
    }
}
